import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'apps/new-web/views/component';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import I18n from 'apps/new-web/views/components/i18n';
import { withStyles } from '@material-ui/core/styles';
import { blueGray54 } from 'apps/new-web/views/themes/colors';

const styles = theme => ({
  label: {
    fontSize: '.75rem',
    fontWeight: 'bold',
    color: blueGray54,
    letterSpacing: '0.04em',
    textTransform: 'uppercase'
  }
});

class RememberMe extends BaseComponent {
  static get propTypes() {
    return {
      checked: PropTypes.bool.isRequired,
      classes: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired
    };
  }

  handleChange() {
    return this.props.handleChange(!this.props.checked);
  }

  render() {
    const { checked, classes } = this.props;
    return (
      <FormControlLabel
        className="remember-me-check"
        classes={{ label: classes.label }}
        control={ <Checkbox
            checked={ checked }
            onChange={ this.handleChange }
            color="primary"
        /> }
        label={ I18n.translate('Remember me', 'Remember the user credentials') }
      />
    );
  }
}

export default withStyles(styles)(RememberMe);
